import {AppAccessStatus} from "../../../../shared/enums/appAccessStatus";
import {EventBookingStatus} from "../../../../shared/enums/eventBookingStatus";

export default class ResidentDetail {
  platformUserId: string;
  firstName: string;
  lastName: string;
  preferredName: string;
  unitCode: string;
  phoneNumber?: string;
  mobileNumber?: string;
  emailAddress?: string;
  appAccountEmail?: string;
  accountStatus?: string;
  townhouseBuddy?: ResidentDetail;
  appAccessStatus?: AppAccessStatus;
  bookingStatus?: EventBookingStatus;
  personTypeId?: string;

  constructor(
    platformUserId: string,
    firstName: string,
    lastName: string,
    preferredName: string,
    unitCode: string,
    phoneNumber?: string,
    mobileNumber?: string,
    emailAddress?: string,
    appAccountEmail?: string,
    accountStatus?: string,
    townhouseBuddy?: ResidentDetail,
    bookingStatus?: EventBookingStatus,
    appAccessStatus?: AppAccessStatus,
    personTypeId?: string
  ) {
    this.platformUserId = platformUserId;
    this.firstName = firstName;
    this.lastName = lastName;
    this.preferredName = preferredName;
    this.unitCode = unitCode;
    this.phoneNumber = phoneNumber;
    this.mobileNumber = mobileNumber;
    this.emailAddress = emailAddress;
    this.appAccountEmail = appAccountEmail;
    this.accountStatus = accountStatus;
    this.townhouseBuddy = townhouseBuddy;
    this.bookingStatus = bookingStatus;
    this.appAccessStatus = appAccessStatus;
    this.personTypeId = personTypeId;
  }

  get hasActiveAccount(): boolean {
    return !!this.appAccountEmail;
  }
}
